
namespace GeniuzPOS.Customer {
    import fld = Report_1106CustomerRow.Fields;
    @Serenity.Decorators.registerClass()
    export class Report_1106CustomerGrid extends Serenity.EntityGrid<Report_1106CustomerRow, any> {
        myGridDropdownButton: Common.Helpers.GridDropdownButton
        protected getColumnsKey() { return Report_1106CustomerColumns.columnsKey; }
        protected getDialogType() { return Report_1106CustomerDialog; }
        protected getIdProperty() { return Report_1106CustomerRow.idProperty; }
        protected getInsertPermission() { return Report_1106CustomerRow.insertPermission; }
        protected getLocalTextPrefix() { return Report_1106CustomerRow.localTextPrefix; }
        protected getService() { return Report_1106CustomerService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
           
        
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];

            

            // console.log(request)
            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();

                let filters = Object.keys(request.EqualityFilter);

                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    // if else{
                    if (filterValue.length > 0) {
                        if (Array.isArray(filterValue)) {
                            if (quickFilter.options.lookupKey) {
                                // console.log(filterValue);
                                (filterValue as any[]).forEach(value => {
                                    var names: string[] = new Array(filterValue);
                                    for (var i = 0; i < names.length; i++) {
                                        filterValue = (names[i]);
                                        console.log(filterValue);
                                    }
                                })

                            }
                        } else {
                            filterValue
                        }
                    }
                    else {
                        filterValue = "ไม่ระบุ"
                    }
                    // }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {
                        descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                    }
                }
            }
            return [descriptions, gridColumns];
        }
        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["CustGroupName"]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1106CustomerService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            let reportTitle = 'รายงานทะเบียนลูกค้า(Product master list)'
            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "CustGroupCode", title: "ประเภท", cellWidth: 20 },
                1: { field: "CustCode", title: "รหัสลูกค้า", cellWidth: 20 ,},
                2: { field: "CustName", title: "ชื่อลูกค้า", cellWidth: 40 ,overflow:'linebreak'},
                3: { field: "CustTaxId", title: "เลขเสียภาษี", cellWidth: 25},
                4: { field: "ContactName", title: "ชื่อผู้ติดต่อ", cellWidth: 40 },
                5: { field: "CusTel", title: "เบอร์", cellWidth: 15 },
                6: { field: "Email", title: "Email", cellWidth: 15 },

                7: { field: "Address", title: "ที่อยู่ติดต่อ", cellWidth: 10,overflow:'linebreak'},
                8: { field: "Tumbol", title: "ตำบล", cellWidth: 10 },
                9: { field: "Amphur", title: "อำเภอ", cellWidth: 10 },
                10: { field: "Province", title: "จังหวัด", cellWidth: 10 },
                11: { field: "ZipCode", title: "รหัส", cellWidth: 10 },                

                12: { field: "CustRegName", title: "ชื่อจดทะเบียน", cellWidth: 15 ,overflow:'linebreak'},
                13: { field: "CustRegAddress", title: "ที่อยู่", cellWidth: 15 ,overflow:'linebreak'},
                14: { field: "CustRegTumbol", title: "ตำบล", cellWidth: 15 },
                15: { field: "CustRegAmphur", title: "อำเภอ", cellWidth: 15 },
                16: { field: "CustRegProvince", title: "จังหวัด", cellWidth: 15 },
                17: { field: "CustRegZipCode", title: "รหัส", cellWidth: 25},
                
                18: { field: "ShipName", title: "ชื่อที่อยู่จัดส่ง", cellWidth: 15 ,overflow:'linebreak'},
                19: { field: "ShipAddress", title: "ที่อยู่จัดส่ง", cellWidth: 15 ,overflow:'linebreak'},
                20: { field: "ShipTumbol", title: "ตำบล", cellWidth: 15 },
                21: { field: "ShipAmphur", title: "อำเภอ", cellWidth: 15 },
                22:{ field: "ShipProvince", title: "จังหวัด", cellWidth: 20 },
                23: { field: "ShipZipCode", title: "รหัส", cellWidth: 20 },
                }
                // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
                //     grid: this,
                //     onViewSubmit: () => this.onViewSubmit(),
                //     reportTitle: reportTitle,
                //     separator: true,
                //     pageNumbers: true,
                //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
                //     columnStyles: columnStyles,
                //     // groupHeader: {
                //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
                //     // },
                //     hideGroupColumn: false,
                //     theme: 'plain',
                //     showTableHead: 'everyPage',
                //     isCustomHeader: true,
                // }));
    
                // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
                //     grid: this,
                //     onViewSubmit: () => this.onViewSubmit(),
                //     reportTitle: reportTitle,
                //     //separator: true,
                   
                //     pageNumbers: true,
                //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
                //     autoPrint: true,
                //     output: "dataurlnewwindow",
                //     columnStyles: columnStyles,
                //     // groupHeader: {
                //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
                //     // },
                //     hideGroupColumn: false,
                //     theme: 'plain',
    
                //     showTableHead: 'everyPage',
                //     isCustomHeader: true,
    
                //     //reportTitle: "This is report title",
                //     titleTop: 7,
                //     titleFontSize: 12,
                //     fileName: "ThisIsTheFileName",
                //     //pageNumbers: true,
                //     columnTitles: {
                //         'OriginalColumn': 'OCol.',
                //     },
                //     tableOptions: {
                //         columnStyles: {
                //             OriginalColumn: {
                //                // columnWidth: 25,
                //                 halign: 'right'
                //             }
                //         }
                //     }
                // }));
                buttons.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );
            return buttons;
        }
        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

           

            this.view.setGrouping(
                [
                {
                    formatter: x => 'ประเภท ' + x.value,
                    getter: 'CustGroupName'
                }
                // ,
                // {
                //     formatter: x => 'รวมรหัสเครื่อง ' + x.value.toString,
                //     getter: 'PosId'
                // }
                ]
            );

            // new Serenity.AutoColumnWidthMixin({
            //     grid: this
            // });

            return grid;
        }
    }
}